<script>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { useAdmin } from 'dashboard/composables/useAdmin';
import { settingsBarVisible } from './settingsBack';
import BackButton from '../../../components/widgets/BackButton.vue';

export default {
  components: {
    BackButton,
  },
  props: {
    headerTitle: {
      default: '',
      type: String,
    },
    icon: {
      default: '',
      type: String,
    },
    showBackButton: { type: Boolean, default: false },
    backUrl: {
      type: [String, Object],
      default: '',
    },
    backButtonLabel: {
      type: String,
      default: '',
    },
  },
  setup() {
    const { isAdmin } = useAdmin();
    const route = useRoute();
    // A barra de contexto já mostra o voltar desta tela; um segundo "Voltar"
    // aqui levava a outro lugar e confundia.
    const hasContextBack = computed(() => settingsBarVisible(route));
    return {
      isAdmin,
      hasContextBack,
    };
  },
  computed: {
    iconClass() {
      return `icon ${this.icon} header--icon`;
    },
  },
};
</script>

<template>
  <div
    class="flex justify-between items-center h-20 min-h-[3.5rem] px-6 py-2 bg-n-surface-1"
  >
    <h1 class="flex items-center mb-0 text-2xl text-n-slate-12">
      <BackButton
        v-if="showBackButton && !hasContextBack"
        :button-label="backButtonLabel"
        :back-url="backUrl"
        class="ltr:mr-4 rtl:ml-4"
      />

      <slot />
      <span class="text-xl font-medium tracking-tight text-n-slate-12">
        {{ headerTitle }}
      </span>
    </h1>
  </div>
</template>
